import React from "react"

const DetailListBadge = ({ children }) => {
  const style = {
    display: "inline",
    padding: 4,
    borderRadius: 4,
    boxShadow: "0px 1px 3px 1px #d8d8d8",
    fontSize: "1.3rem",
    marginRight: 8,
  }

  return (
    <div style={style}>
      <span style={{ color: "#004c6e" }}>{children}</span>
    </div>
  )
}

export default DetailListBadge
